/**
 * Attention highlight — последовательная пульсация ключевых UI-элементов
 * при загрузке страницы, чтобы обратить внимание пользователя на функционал.
 *
 * Очередь: #search-settings-button, .langs-book-icon, #search-history-button, #logo-cell.
 * Скрытые элементы пропускаются (видимость = offsetParent + computed styles).
 */

(function () {
  'use strict';

  var SELECTORS = [
    '#search-history-button',   // 1. История
    '#logo-cell',               // 2. Логотип (тема)
    '#search-mode-toggle',      // 3. +AI
    '#search-settings-button',  // 4. Настройки
    '.langs-book-icon'          // 5. Помощь
  ];
  var INITIAL_DELAY = 800;   // ждём пока отрендерится layout и уляжется FOUC
  var DELAY_BETWEEN = 1180;  // интервал между стартами пульсаций (небольшая пауза после завершения предыдущей)
  var PULSE_DURATION = 1150; // должно совпадать с длительностью CSS-анимации

  function isVisible(el) {
    if (!el) return false;
    if (el.hidden) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    // offsetParent null для элементов в display:none ветках либо position:fixed
    // с display:none у самого элемента — второе уже поймали выше.
    if (el.offsetParent === null && style.position !== 'fixed') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function pulse(el) {
    if (!el) return;
    el.classList.remove('attention-pulse');
    // Reflow, чтобы анимация перезапустилась при повторном вызове.
    void el.offsetWidth;
    el.classList.add('attention-pulse');
    setTimeout(function () {
      el.classList.remove('attention-pulse');
    }, PULSE_DURATION);
  }

  function run() {
    var elements = [];
    SELECTORS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && isVisible(el)) elements.push(el);
    });
    elements.forEach(function (el, i) {
      setTimeout(function () { pulse(el); }, i * DELAY_BETWEEN);
    });
  }

  function start() { setTimeout(run, INITIAL_DELAY); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
